// extracted by mini-css-extract-plugin
export default {"cardInfo":"CardInfo_cardInfo__uLngr","icon":"CardInfo_icon__tcaNc","name":"CardInfo_name__Wy6vM","count":"CardInfo_count__WI-Tv","ratio":"CardInfo_ratio__8gsP2"};